<script lang="ts" setup>
import type { PropType } from 'vue'
import ShipPreviewApproval from '@/components/import/ShipPreviewApproval.vue'
import ShipPreviewParameterTable from '@/components/import/ShipPreviewParameterTable.vue'
import { storeToRefs } from 'pinia'
import DocumentTable from '@/components/document/DocumentTable.vue'
import { useShipStore } from '@/stores/ship'
import { useAuthenticationStore } from '@/stores/authentication'
import type { ShipType } from '@/stores/type/ship.type'

const props = defineProps({
  ship: { type: Object as PropType<ShipType>, required: true },
  chartEvent: { type: String as PropType<string>, required: true }
})

const { user } = storeToRefs(useAuthenticationStore())
const { previewDocumentDialog, importSuccess } = storeToRefs(useShipStore())

const isAdmin = computed<boolean>(() => {
  return user.value ? user.value.is_superuser : false
})

const cols = computed<number>(() => {
  return isAdmin.value ? 8 : 12
})
</script>

<template>
  <v-card class="fill-height preview-parameter" flat>
    <template v-if="ship">
      <div class="preview-parameter__main">
        <ShipPreviewParameterTable :chart-event="chartEvent" :is-admin="isAdmin" :ship="ship" />
      </div>
      <v-divider thickness="2"></v-divider>
      <v-row no-gutters class="preview-parameter__secondary">
        <v-col v-if="isAdmin" cols="4" class="fill-height" style="border-right: #e4e4e4 solid 2px">
          <ShipPreviewApproval :ship="ship" table-height="100%" />
        </v-col>
        <v-divider v-if="isAdmin" vertical></v-divider>
        <v-col :cols="cols" class="fill-height">
          <DocumentTable
            :add-document="!importSuccess"
            table-height="100%"
            @add="previewDocumentDialog = true"
          ></DocumentTable>
        </v-col>
      </v-row>
    </template>
  </v-card>
</template>

<style scoped>
.preview-parameter {
  display: grid;
  grid-template-rows: minmax(0, 2fr) auto minmax(0, 1fr);
  min-height: 0;
}

.preview-parameter__main,
.preview-parameter__secondary {
  min-height: 0;
}
</style>
